import React, {StrictMode, useEffect, useState} from 'react';

function Captcha(props) {
    const [captchaWord, setCaptchaWord] = useState("");

    const handleCaptchaChange = (e) => {
        setCaptchaWord(e.target.value);
    };

    useEffect(() => {
        setCaptchaWord("");
    }, [props]);

    const captchaErrors = props.errors.filter(error => error.CODE === 'CAPTCHA_WRONG')
    if (captchaErrors.length === 0) {
        return null;
    }

    return (
        <div className="max-w-xs mb-2">
            <p className="text-left font-medium mb-2 text-textLight dark:text-textDarkLightGray text-base">
                Введите текст с картинки:</p>
            <input type="text" name="captcha_word" required
                   className="bg-textDark p-3 mb-2 dark:bg-grayButton cursor-pointer
                   w-full text-textLight rounded-md text-center dark:text-white border-0 text-xl"
                   value={captchaWord}
                   onChange={handleCaptchaChange}
            />
            {props.captcha && (
                <div className="mt-2">
                    <img src={'/bitrix/tools/captcha.php?captcha_sid=' + props.captcha} alt="Капча" title="Обновить капчу"
                         className=""/>
                    <input type="hidden" name="captcha_sid" value={props.captcha} />
                </div>
            )}
        </div>
    );
}

export default Captcha;